import { render, staticRenderFns } from "./BudgetError.vue?vue&type=template&id=490ee627"
import script from "./BudgetError.vue?vue&type=script&lang=js"
export * from "./BudgetError.vue?vue&type=script&lang=js"
import style0 from "./BudgetError.vue?vue&type=style&index=0&id=490ee627&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports